import type { ReactNode } from "react";
import { Card, CardContent } from "@runcheetah/ui";

import { cn } from "@/lib/utils";

export interface EmptyCardProps {
  children: ReactNode;
  icon?: ReactNode;
  className?: string;
  contentClassName?: string;
}

export function EmptyCard({ children, icon, className, contentClassName }: EmptyCardProps) {
  return (
    <Card className={className}>
      <CardContent
        className={cn(
          "flex min-h-40 flex-col items-center justify-center gap-2 py-12 text-center text-sm text-muted-foreground",
          contentClassName,
        )}
      >
        {icon ? <div className="text-muted-foreground/60">{icon}</div> : null}
        {children}
      </CardContent>
    </Card>
  );
}
